import { z } from 'zod';

import { levelEnumValidator, toneModeEnumValidator } from '../../validators';

export const RephraseSentenceResponseSchema = z.object({
  level: levelEnumValidator.nullable().optional(),
  originalSentence: z.string(),
  rephrasedSentence: z.string(),
  tone: toneModeEnumValidator,
});

export type IRephraseSentenceResponseDto = z.infer<
  typeof RephraseSentenceResponseSchema
>;
